module.exports = __webpack_public_path__ + "/images/logo-af-kiabi.d3a1c97.svg";